import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Modal } from '../models/modal.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ModalApiService {
  constructor(private apiService: ApiService) {}

  public getModal(): Observable<Modal> {
    return this.apiService.get<Modal>('/customers/modals/any', null, true, 'modals');
  }

  public deleteModal(modalId: string): Observable<void> {
    return this.apiService.delete(`/customers/modals/${modalId}`);
  }

  public searchForCampaign(campaignId: string): Observable<Modal> {
    return this.apiService.get('/customers/modals/search', { campaignId });
  }
}
